export const Levels = [0, 1, 2, 3, 4, 5, 6, 7];

export const LevelTranslationKeyMap: Map<number, string> = new Map(Levels.map(level => [level, `level${level}`]));
